import { I18n } from '@app/i18n/strings-keys';

export enum STAND_WORKSHEET_STATUS_VALUE {
  Open = 'open',
  Approved = 'approved',
  Completed = 'completed',
  Canceled = 'canceled',
}

export enum STAND_WORKSHEET_STATUS_NAME {
  Open = 'Open',
  Approved = 'Approved',
  Completed = 'Completed',
  Canceled = 'Canceled',
}

export const STAND_WORKSHEET_STATUS_OPTIONS = {
  [STAND_WORKSHEET_STATUS_VALUE.Open]: I18n.Status.Open,
  [STAND_WORKSHEET_STATUS_VALUE.Approved]: I18n.Status.Approved,
  [STAND_WORKSHEET_STATUS_VALUE.Completed]: I18n.Status.Completed,
  [STAND_WORKSHEET_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
};

// #TODO is need just translation this directly
export enum STAND_WORKSHEET_OPERATION {
  Approved = 'Approved',
  Reopened = 'Reopened',
}

export const STAND_WORKSHEET_STATUS_ENUM_OPTIONS = Object.freeze({
  [STAND_WORKSHEET_STATUS_VALUE.Open]: I18n.Status.Open,
  [STAND_WORKSHEET_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
  [STAND_WORKSHEET_STATUS_VALUE.Completed]: I18n.Status.Completed,
  [STAND_WORKSHEET_STATUS_VALUE.Approved]: I18n.Status.Approved,
});

export const STAND_WORKSHEET_STATUS_ENUM_OPTIONS_Lower = Object.freeze({
  [STAND_WORKSHEET_STATUS_VALUE.Open]: I18n.Status.open,
  [STAND_WORKSHEET_STATUS_VALUE.Canceled]: I18n.Status.canceled,
  [STAND_WORKSHEET_STATUS_VALUE.Completed]: I18n.Status.completed,
  [STAND_WORKSHEET_STATUS_VALUE.Approved]: I18n.Status.approved,
});

export const STAND_WORKSHEET_STATUS_OPTIONS_FOR_FILTER = [
  {
    text: STAND_WORKSHEET_STATUS_ENUM_OPTIONS.open,
    value: STAND_WORKSHEET_STATUS_VALUE.Open,
  },
  {
    text: STAND_WORKSHEET_STATUS_ENUM_OPTIONS.approved,
    value: STAND_WORKSHEET_STATUS_VALUE.Approved,
  },
  {
    text: STAND_WORKSHEET_STATUS_ENUM_OPTIONS.completed,
    value: STAND_WORKSHEET_STATUS_VALUE.Completed,
  },
  {
    text: STAND_WORKSHEET_STATUS_ENUM_OPTIONS.canceled,
    value: STAND_WORKSHEET_STATUS_VALUE.Canceled,
  },
];

export const STAND_WORKSHEET_ORDER_TYPE_OPTIONS_FOR_FILTER = [
  {
    text: I18n.Forms.StandWorksheetForm.Gratis,
    value: 'gratis',
  },
  {
    text: I18n.Forms.StandWorksheetForm.IngredientSpoil,
    value: 'ingredient_spoil',
  },
  {
    text: I18n.Forms.StandWorksheetForm.ProductCount,
    value: 'product_count',
  },
  {
    text: I18n.Forms.StandWorksheetForm.Refund,
    value: 'refund',
  },
  {
    text: I18n.Forms.StandWorksheetForm.Sale,
    value: 'sale',
  },
  {
    text: I18n.Forms.StandWorksheetForm.VoidedPostPayment,
    value: 'voided_post_payment',
  },
];

export const STAND_WORKSHEET_ORDER_TYPE_OPTIONS_FOR_RENDER = {
  gratis: I18n.Forms.StandWorksheetForm.Gratis,
  ingredient_spoil: I18n.Forms.StandWorksheetForm.IngredientSpoil,
  product_count: I18n.Forms.StandWorksheetForm.ProductCount,
  refund: I18n.Forms.StandWorksheetForm.Refund,
  sale: I18n.Forms.StandWorksheetForm.Sale,
  voided_post_payment: I18n.Forms.StandWorksheetForm.VoidedPostPayment,
};

export enum STAND_WORKSHEET_STATUS_TOTAL_NAME {
  Total = 'Total',
}

export enum STAND_WORKSHEET_STATUS_TOTAL_VALUE {
  Total = 'total',
}
